module.exports = __webpack_public_path__ + "media/assets/images/blog/customer_service_attività-16e4afe1f47caedc68251782185bddc6.png";